import React, { forwardRef } from 'react'
import { Radio, RadioProps } from '@rebass/forms'

type Props = RadioProps

const FRadio = forwardRef<any, Props>((props: Props, ref) => {
    const { sx, ...otherProps } = props
    return <Radio ref={ref} sx={{ ...sx }} {...otherProps} />
})

FRadio.displayName = 'FRadio'

export default FRadio
